import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=7b6407ee&scoped=true&"
import script from "./SystemNotification.vue?vue&type=script&lang=js&"
export * from "./SystemNotification.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&id=7b6407ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6407ee",
  null
  
)

export default component.exports